export const ROUTES = {
  LOGIN: '/login',
  UNAUTHORIZED: '/unauthorized',
  FORBIDDEN: '/forbidden',
  NOT_FOUND: '*',

  DASHBOARD: '/',

  // Mobile app launcher, notifications inbox, and global account/settings hub
  WORKSPACE: '/workspace',
  NOTIFICATIONS: '/notifications',
  /** Mobile "Settings" tab — account, theme, logout; links into ROUTES.SETTINGS when permitted */
  ACCOUNT: '/account',
  /** Change own password — also the forced screen while mustChangePassword is set */
  CHANGE_PASSWORD: '/account/password',
  /** Own signed-in devices */
  MY_DEVICES: '/account/devices',
  /** Create PIN — also the forced screen while the role requires an unset PIN */
  PIN_SETUP: '/account/pin/setup',
  CHANGE_PIN: '/account/pin',
  /** Inbound Android / PWA Share Target review — not a business module */
  MOBILE_SHARE: '/mobile/share',
  /** @deprecated Prefer WORKSPACE — old mobile "More" URL, kept as a redirect */
  MORE: '/more',

  // Database (workbook Database sheet)
  MASTER_DATA: '/master-data',
  CUSTOMERS: '/master-data/customers',
  CUSTOMERS_CREATE: '/master-data/customers/new',
  CUSTOMERS_VIEW: '/master-data/customers/:id',
  CUSTOMERS_EDIT: '/master-data/customers/:id/edit',
  PRODUCTS: '/master-data/products',
  PRODUCTS_CREATE: '/master-data/products/new',
  PRODUCT_VIEW: '/master-data/products/:id',
  /** Sellable catalog (Design + color + quality + price + image) */
  CATALOG: '/catalog',
  CATALOG_CREATE: '/catalog/new',
  CATALOG_VIEW: '/catalog/:id',
  CATALOG_EDIT: '/catalog/:id/edit',
  CATALOG_SKUS: '/catalog/:id/skus',
  CATEGORIES: '/master-data/categories',
  CATEGORIES_VIEW: '/master-data/categories/:id',
  QUALITIES: '/master-data/qualities',
  COLOURS: '/master-data/colours',
  WAREHOUSES: '/master-data/warehouses',
  FACTORIES: '/master-data/factories',
  SUPPLIERS: '/master-data/suppliers',
  SUPPLIERS_CREATE: '/master-data/suppliers/new',
  SUPPLIERS_VIEW: '/master-data/suppliers/:id',
  SUPPLIERS_EDIT: '/master-data/suppliers/:id/edit',
  SALES_AGENTS: '/master-data/sales-agents',

  /** @deprecated Prefer CUSTOMERS — Party Names */
  PARTY_NAMES: '/master-data/customers',
  /** @deprecated Prefer SUPPLIERS — Vendor Names */
  VENDOR_NAMES: '/master-data/suppliers',
  /** Designs / sub-categories under Categories */
  DESIGNS: '/master-data/products',

  // Sales
  SALES_ORDERS: '/sales/orders',
  SALES_RETURNS: '/sales/returns',
  SALES_LEADS: '/sales/leads',
  SALES_LEADS_CREATE: '/sales/leads/new',
  SALES_LEADS_OLD_VIEW: '/sales/leads/old/:id',
  SALES_LEADS_INBOX_VIEW: '/sales/leads/inbox/:id',
  SALES_LEADS_VIEW: '/sales/leads/:id',
  SALES_LEADS_REGISTER: '/sales/leads/:id/register',
  QUOTATIONS: '/sales/quotations',
  QUOTATIONS_CREATE: '/sales/quotations/new',
  QUOTATION_VIEW: '/sales/quotations/:id',
  ESTIMATES: '/sales/estimates',
  ESTIMATES_CREATE: '/sales/estimates/new',
  ESTIMATE_VIEW: '/sales/estimates/:id',

  /** Company bank accounts printed on GST estimates. */
  COMPANY_BANK_ACCOUNTS: '/company/bank-accounts',

  // Inventory
  CURRENT_STOCK: '/inventory/current-stock',
  WAREHOUSE_STOCK: '/inventory/warehouse-stock',
  STOCK_MOVEMENTS: '/inventory/stock-movements',
  STOCK_ADJUSTMENTS: '/inventory/stock-adjustments',
  WAREHOUSE_TRANSFERS: '/inventory/warehouse-transfers',

  // Production
  DAILY_PRODUCTION: '/production/daily',
  PRODUCTION_HISTORY: '/production/history',

  // Dispatch (workbook Dispatch sheet)
  DISPATCH_SHEET: '/dispatch/sheet',
  DISPATCH_SHEET_CREATE: '/dispatch/sheet/new',
  DISPATCH_SHEET_VIEW: '/dispatch/sheet/:id',
  DISPATCH_SHEET_EDIT: '/dispatch/sheet/:id/edit',
  DELIVERY_CHALLANS: '/dispatch/delivery-challans',
  GATE_PASSES: '/dispatch/gate-passes',

  // Purchases (workbook Purchase sheet)
  PURCHASE_SHEET: '/purchases/sheet',
  PURCHASE_SHEET_CREATE: '/purchases/sheet/new',
  PURCHASE_SHEET_VIEW: '/purchases/sheet/:id',
  PURCHASE_SHEET_EDIT: '/purchases/sheet/:id/edit',
  PURCHASE_ORDERS: '/purchases/orders',
  GOODS_RECEIVED: '/purchases/goods-received',

  // Finance
  INVOICES: '/finance/invoices',
  CUSTOMER_PAYMENTS: '/finance/customer-payments',
  SUPPLIER_PAYMENTS: '/finance/supplier-payments',
  CASH_BOOK: '/finance/cash-book',
  CUSTOMER_LEDGER: '/finance/customer-ledger',
  SUPPLIER_LEDGER: '/finance/supplier-ledger',

  // Tasks
  TASKS: '/tasks',
  TASKS_CREATE: '/tasks/new',
  TASKS_EDIT: '/tasks/:id/edit',
  TASKS_VIEW: '/tasks/:id',

  // Messenger
  MESSENGER: '/messenger',
  MESSENGER_CHAT: '/messenger/:chatId',

  // Reports / Settings / Users
  REPORTS: '/reports',
  REPORTS_PURCHASE_SUMMARY: '/reports/purchases/summary',
  REPORTS_PURCHASE_TREND: '/reports/purchases/summary/trend',
  REPORTS_DISPATCH_SUMMARY: '/reports/dispatches/summary',
  REPORTS_DISPATCH_TREND: '/reports/dispatches/summary/trend',
  REPORTS_EXPORTS: '/reports/exports',
  /** @deprecated Combined summary — use purchase/dispatch summary routes */
  REPORTS_SUMMARY: '/reports/summary',
  SETTINGS: '/settings',
  SETTINGS_SHEETS_SYNC: '/settings/sheets-sync',
  SETTINGS_SECURITY: '/settings/security',
  SETTINGS_BACKUPS: '/settings/backups',
  SETTINGS_EMAIL: '/settings/email',
  SETTINGS_SITE_FORM: '/settings/website-form',
  QUOTATION_TERMS_TEMPLATES: '/sales/quotations/terms',
  /** Old Settings path — redirects to QUOTATION_TERMS_TEMPLATES. */
  QUOTATION_TERMS_TEMPLATES_LEGACY: '/settings/quotation-terms-templates',
  USERS: '/users',
  USERS_CREATE: '/users/create',
  USERS_AGENT_LINKS: '/users/agent-links',
  USERS_EDIT: '/users/:id/edit',
  USERS_VIEW: '/users/:id',
  PERMISSIONS: '/users/permissions',
} as const

export type AppRoute = (typeof ROUTES)[keyof typeof ROUTES]
